import { MenuItem, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { useDispatch } from 'react-redux';
import { validateEmail } from '../../shared/util/emailValidators';
import { showSnackbar } from '../../store/rootReducer';

const EMPTY = { user_email: '', role: '' };
export default function EditAdminModal({ open, onClose, admin, roles, saveAdmin, isNew }) {
  const [values, setValues] = useState({ user_email: '', role: '' });
  const dispatch = useDispatch();
  useEffect(() => {
    setValues(admin ? { ...admin } : EMPTY);
  }, [admin]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleSave = async () => {
    try {
      await saveAdmin(values, isNew);
    } catch (err) {
      dispatch(
        showSnackbar({
          message: err.message || 'Server error, please try again.',
          severity: 'error',
        })
      );
    } finally {
      setValues(EMPTY);
      onClose();
    }
  };

  const roleList = Object.values(roles).sort((a, b) => {
    const p1 = a.sortPriority ?? 9999;
    const p2 = b.sortPriority ?? 9999;
    if (p1 !== p2) return p1 - p2;
    return a.label.localeCompare(b.label);
  });

  const isSaveDisabled = !values.user_email || !values.role || !validateEmail(values.user_email);

  return (
    <Modal show={open} animation={false}>
      <Modal.Header>
        <Modal.Title>{admin ? 'Edit Admin' : 'Add Admin'}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <TextField
          fullWidth
          margin="normal"
          label="Email"
          name="user_email"
          value={values.user_email}
          onChange={handleChange}
          disabled={!isNew}
        />
        <TextField
          fullWidth
          select
          margin="normal"
          label="Role"
          name="role"
          value={values.role}
          onChange={handleChange}
        >
          {roleList.map((r) => (
            <MenuItem key={r.id} value={r.id}>
              {r.label}
            </MenuItem>
          ))}
        </TextField>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={handleSave} disabled={isSaveDisabled}>
          Save
        </Button>
        <Button variant="cancel" onClick={onClose}>
          Cancel
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
